import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  Button,
  Form,
  minValue,
  NumberInput,
  required,
  SaveButton,
  TextInput,
  Toolbar,
  useDataProvider,
  useNotify,
  useTranslate,
} from "react-admin";
import { FieldValues, SubmitHandler } from "react-hook-form";
import OtpInput from "./OtpInput";
import { extractErrorMessage } from "@/utilities/errorExtract";

type DialogConsumeVoucherProps = {
  open: boolean;
  onClose: () => void;
};

type VoucherCode = {
  code: string;
  pseudo: string;
  invoice_amount: number;
};

const DialogConsumeVoucher = ({ open, onClose }: DialogConsumeVoucherProps) => {
  const translate = useTranslate();
  const notify = useNotify();
  const dp = useDataProvider();

  const handleSubmit = async (values: VoucherCode) => {
    const { code = "", pseudo = "", invoice_amount = 0 } = values;

    try {
      await dp.consumeVoucher({ code, pseudo, invoice_amount });
      notify("ra.gameoo.consumeSuccess", {
        type: "info",
        messageArgs: { code, pseudo, invoice_amount },
      });
      onClose();
    } catch (e) {
      notify(extractErrorMessage(e), { type: "warning" });
    }
  };

  const onSubmit: SubmitHandler<FieldValues> = (raw) =>
    handleSubmit(raw as VoucherCode);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{translate("ra.gameoo.consumeVoucherTitle")}</DialogTitle>
      <Form onSubmit={onSubmit}>
        <DialogContent>
          <Typography variant="body2" gutterBottom>
            {translate("ra.gameoo.consumeVoucherInstruction")}
          </Typography>
          <OtpInput source="code" length={8} />
          <Typography variant="body2" gutterBottom mt="20px">
            {translate("ra.gameoo.consumeVoucherInstructionPseudo")}
          </Typography>
          <TextInput source="pseudo" label="Pseudo" fullWidth />
          <Typography variant="body2" gutterBottom>
            {translate("ra.gameoo.consumeVoucherInstructionInvoiceAmount")}
          </Typography>
          <NumberInput
            source="invoice_amount"
            label="Montant (en Ariary)"
            validate={[required(), minValue(3000)]}
            min={3000}
            step={1}
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={onClose}
            label={translate("ra.gameoo.consumeCancel")}
          />
          <Toolbar>
            <SaveButton
              label={translate("ra.gameoo.consumeValidate")}
              alwaysEnable
            />
          </Toolbar>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default DialogConsumeVoucher;
